import React from 'react'
import { withRouter } from 'react-router-dom'

import Arrow from '../../icons/Arrow'

import { loadIcon } from '../../services/helpers'

import './category-widget.css'

const CategoryWidget = (props) => {
  const { name, itemId, history } = props
  return (
    <div className='category-widget' onClick={() => itemId && history.push(`/catalog?category=${itemId}`)}>
      <img src={loadIcon(`categories/${itemId}.jpeg`)} alt={name} width={140} height={120} />
      <div className='name'>{name}</div>
      <span className='category-widget__arrow' />
      <span className='category-widget__arrow'>
        <Arrow />
      </span>
    </div>
  )
}

export default withRouter(CategoryWidget)
